// A ring of rings.
//
// Added because two chapters asked for it rather than on principle: 25 runs
// 9000 particles over (R + r cos v) cos u, and 33 walks 40 by 40 field lines
// across the same surface. grid is a plane, polar a disc, column a tube —
// none of them is a donut, and approximating one with any of them was going
// to be a worse answer than a forty-line file.
//
// Emitted ring by ring in u, so each run is one closed poloidal loop and a
// path mark walks the small circles. Radii are normalised so the outer edge
// reaches 1 whatever the minor ratio, which keeps a torus framed like every
// other substrate.
import { mulberry32 } from '../rng.js'

export default {
  id: 'torus',
  label: 'Torus',
  motion: 'resample',
  params: [
    { key: 'rings', label: 'rings', tier: 'structural', min: 6, max: 72, step: 1, default: 36 },
    { key: 'around', label: 'per ring', tier: 'structural', min: 3, max: 48, step: 1, default: 16 },
    // r / R. At 0 the torus collapses toward a circle, near 1 the hole closes.
    { key: 'minor', label: 'thickness', tier: 'structural', min: 0.05, max: 0.9, step: 0.01, default: 0.45 },
    { key: 'spin', label: 'ring offset', tier: 'structural', min: 0, max: 0.5, step: 0.005, default: 0 },
    { key: 'jitter', label: 'jitter', tier: 'structural', min: 0, max: 1, step: 0.02, default: 0 },
  ],

  build(cfg, seed) {
    const rnd = mulberry32(seed)
    const rings = Math.max(3, Math.round(cfg.rings))
    const around = Math.max(3, Math.round(cfg.around))
    // R + r = 1, so the silhouette always fills the frame.
    const r = cfg.minor / (1 + cfg.minor)
    const R = 1 / (1 + cfg.minor)
    const pts = new Float32Array(rings * around * 3)
    const runs = new Int32Array(rings)
    runs.fill(around)
    let i = 0
    for (let a = 0; a < rings; a++) {
      const u = (a / rings) * Math.PI * 2
      const cu = Math.cos(u), su = Math.sin(u)
      const off = a * cfg.spin
      for (let b = 0; b < around; b++) {
        const v = ((b / around) + off) * Math.PI * 2
        const j = 1 + (rnd() - 0.5) * cfg.jitter
        const ring = (R + r * Math.cos(v)) * j
        pts[i++] = ring * cu
        pts[i++] = ring * su
        pts[i++] = r * Math.sin(v) * j
      }
    }
    return { points: pts, count: rings * around, runs, closed: true }
  },
}
